module.exports = __webpack_public_path__ + "img/calendar.baf7ab9d.svg";